module.exports = __webpack_public_path__ + "img/brand-block-8.1ff03221.png";